import * as actionType from '../actions/actionTypes';
import updateObject from '../Utility';
import { isTodayDateTime } from '../../util/functions'

// export const MAKE_CALL='MAKE_CALL';
// export const DISCONNECT_CALL='DISCONNECT_CALL';

const initState = {
    calls: [],
    nowCall: null,
    dialList: [],
    multiSelectCallsCount: 0,
    multiSelectdialListCount: 0,
    totalCountOfCalls: 0,
    totalCountOfDialList: 0,
    todayCallCount: 0

}

const sortDialList = (a, b) => {
    if (a.status > b.status) {
        return -1
    }
    else if (a.status < b.status) {
        return 1
    }
    else {
        return a.startTime < b.startTime ? -1 : 1
    }
}

const fetchCallsSuccess = (state, action) => {
    return updateObject(state, { calls: action.calls.calls, totalCountOfCalls: action.calls.totalCountOfCalls, todayCallCount: action.calls.todayCallCount });
}

const CallReceivedEvent = (state, action) => {//todo112
    if (state.nowCall) {
        return state//updateObject(state, { totalCountOfCalls: (state.totalCountOfCalls + 1) })
        // return state;
    };
    return updateObject(state, { nowCall: action.nowCall, totalCountOfCalls: (state.totalCountOfCalls + 1), todayCallCount: (state.todayCallCount + 1) });
}
const CallAnsweredEvent = (state, action) => {
    if (!state.nowCall) return state;
    if (state.nowCall.callId !== action.nowCall.callId) return state;
    return updateObject(state, { nowCall: action.nowCall });
}

const callHoldEvent = (state, action) => {//todo112
    if (!state.nowCall || state.nowCall.callId !== action.payload.callId) return state
    const nowCall = { ...state.nowCall }
    nowCall.isOnHold = action.payload.isOnHold
    return updateObject(state, { nowCall });
}


const CallReleasedEvent = (state, action) => {
    const calls = [...state.calls]
    if (action.nowCall.releasingMode) {
        calls.unshift(action.nowCall);
    }
    if (!state.nowCall || state.nowCall.callId !== action.nowCall.callId) {
        return updateObject(state, { calls: calls });
    }

    if (state.nowCall.callId === action.nowCall.callId) {
        return updateObject(state, { calls: calls, nowCall: null });
    }
    return state;
}

const clearNowCall = (state, action) => {
    return updateObject(state, { nowCall: null })
}


const fetchDialList = (state, action) => {//todo

    return updateObject(state, { dialList: action.dialList.dialList, totalCountOfDialList: action.dialList.totalCountOfDialList });
}
const dialListAdded = (state, action) => {
    const newDialList = [...state.dialList];
    newDialList.push(action.dialItem);
    newDialList.sort(sortDialList);
    return updateObject(state, { dialList: newDialList, totalCountOfDialList: (state.totalCountOfDialList + 1) });
}
const dialListUpdated = (state, action) => {
    const newDialList = [...state.dialList];
    if (action.dialList.all === true) {
        newDialList.forEach(dialItem => {
            if (action.dialList.data.startTime !== undefined) dialItem.startTime = action.dialList.data.startTime
            if (action.dialList.data.status !== undefined) dialItem.status = action.dialList.data.status
            if (action.dialList.data.desc !== undefined) dialItem.desc = action.dialList.data.desc
        })
    }
    else {
        action.dialList.data.forEach(dialItemInUpdated => {
            let i = newDialList.findIndex(dialItemInState => {
                return dialItemInUpdated._id === dialItemInState._id
            })

            if (i !== undefined && i !== null && i > -1) {
                if (dialItemInUpdated.startTime !== undefined) newDialList[i].startTime = dialItemInUpdated.startTime;
                if (dialItemInUpdated.status !== undefined) newDialList[i].status = dialItemInUpdated.status;
                if (dialItemInUpdated.desc !== undefined) newDialList[i].desc = dialItemInUpdated.desc;
            }
        });
    }
    newDialList.sort(sortDialList);
    return updateObject(state, { dialList: newDialList });
}


const dialListDeleted = (state, action) => {
    // console.log(action.dialList)
    let newDialList = [...state.dialList];
    if (action.dialList.all === true) {
        newDialList = []
        return updateObject(state, { dialList: newDialList, totalCountOfDialList: 0 });
    }
    else {
        action.dialList.data.forEach(dialItemInDeleted => {
            const i = newDialList.findIndex(dialItemInState => {
                return dialItemInDeleted._id === dialItemInState._id
            })
            if (i !== undefined && i !== null && i > -1) {
                newDialList.splice(i, 1);
            }
        });
        newDialList.sort(sortDialList);
        return updateObject(state, { dialList: newDialList, totalCountOfDialList: (state.totalCountOfDialList - 1) });
    }


}

const dialListAutoDeleted = (state, action) => {
    const deletedItemId = action.dialList._id;
    const newDialList = state.dialList.filter((dialItem) => dialItem._id !== deletedItemId);
    return updateObject(state, { dialList: newDialList });
};

const callDeleted = (state, action) => {//totalCountOfCalls: (state.totalCountOfCalls+1)
    let newCalls = [...state.calls];
    if (action.calls.all === true) {
        newCalls = []
        return updateObject(state, { calls: newCalls, totalCountOfCalls: 0, todayCallCount: 0 });
    }
    else {
        const deletedCallsFromToday = []
        action.calls.data.forEach(callItemInDeleted => {
            const i = newCalls.findIndex(callItemInState => {
                return callItemInDeleted._id === callItemInState._id
            })
            if (i > -1) {
                const deletedCall = (newCalls.splice(i, 1))[0]
                if (deletedCall && isTodayDateTime(deletedCall.startTime)) deletedCallsFromToday.push(deletedCall)
            }
        });
        newCalls.sort((a, b) => a.startTime < b.startTime ? 1 : -1);
        let updateStatePart = { calls: newCalls, totalCountOfCalls: (state.totalCountOfCalls - 1) }
        if (deletedCallsFromToday.length > 0 && (state.todayCallCount - deletedCallsFromToday.length) > -1) {//isTodayDateTime
            updateStatePart.todayCallCount = state.todayCallCount - deletedCallsFromToday.length
        }
        return updateObject(state, updateStatePart);
    }
}

const multiSelectUnselectCalls = (state, action) => {
    let callsArr = [...state.calls]
    let multiSelectCallsCount = state.multiSelectCallsCount
    const callIndex = callsArr.findIndex(call => (
        call._id === action._id
    ))
    if (callIndex < 0) {
        //do nothing
    }
    else {
        callsArr[callIndex].isCallMultiSelected = !callsArr[callIndex].isCallMultiSelected
        if (callsArr[callIndex].isCallMultiSelected) {
            multiSelectCallsCount++
        }
        else {
            multiSelectCallsCount--
        }
    }

    return updateObject(state, {
        calls: callsArr,
        multiSelectCallsCount: multiSelectCallsCount
    })
}
const multiSelectUnselectAllCalls = (state, action) => {
    let callsArr = [...state.calls]
    let multiSelectCallsCount = undefined
    if (action.selectType === 'selectall') {
        callsArr.forEach(call => {
            call.isCallMultiSelected = true
        })
        multiSelectCallsCount = callsArr.length
    }
    else {
        callsArr.forEach(call => {
            call.isCallMultiSelected = false
        })
        multiSelectCallsCount = 0
    }
    return updateObject(state, {
        multiSelectCallsCount: multiSelectCallsCount,
        calls: callsArr
    })
}

const multiSelectUnselectDialList = (state, action) => {
    let dialListArr = [...state.dialList]
    let multiSelectdialListCount = state.multiSelectdialListCount
    const dialListIndex = dialListArr.findIndex(dialItem => (
        dialItem._id === action._id
    ))
    if (dialListIndex < 0) {
        //do nothing
    }
    else {
        dialListArr[dialListIndex].isDialItemMultiSelected = !dialListArr[dialListIndex].isDialItemMultiSelected
        if (dialListArr[dialListIndex].isDialItemMultiSelected) {
            multiSelectdialListCount++
        }
        else {
            multiSelectdialListCount--
        }
    }

    return updateObject(state, {
        dialList: dialListArr,
        multiSelectdialListCount: multiSelectdialListCount
    })
}
const multiSelectUnselectAllDialList = (state, action) => {
    let dialListArr = [...state.dialList]
    let multiSelectdialListCount = undefined
    if (action.selectType === 'selectall') {
        dialListArr.forEach(dialItem => {
            dialItem.isDialItemMultiSelected = true
        })
        multiSelectdialListCount = dialListArr.length
    }
    else {
        dialListArr.forEach(dialItem => {
            dialItem.isDialItemMultiSelected = false
        })
        multiSelectdialListCount = 0
    }
    return updateObject(state, {
        multiSelectdialListCount: multiSelectdialListCount,
        dialList: dialListArr
    })
}

const callDetailsUpdate = (state, action) => {//totalCountOfCalls: (state.totalCountOfCalls+1)
    let stateCalls = [...state.calls];

    let foundCallIndex = stateCalls.findIndex(call => call._id === action.call._id)

    if (foundCallIndex > -1) {
        stateCalls[foundCallIndex] = { ...stateCalls[foundCallIndex], ...action.call }
    }

    return updateObject(state, { calls: stateCalls });

}

const dialListDetailsUpdate = (state, action) => {//totalCountOfCalls: (state.totalCountOfCalls+1)
    let stateDialLists = [...state.dialList];

    let foundDialListIndex = stateDialLists.findIndex(dialList => dialList._id === action.dialList._id)

    if (foundDialListIndex > -1) {
        stateDialLists[foundDialListIndex] = { ...stateDialLists[foundDialListIndex], ...action.dialList }
    }

    return updateObject(state, { dialList: stateDialLists });

}

const CallConfStart = (state, action) => {

    let nowCallCopy = { ...state.nowCall }
    nowCallCopy.callId2 = action.callId
    nowCallCopy.telephone2 = action.phone
    return updateObject(state, { nowCall: nowCallCopy });
}

const clearDialerState = (state, action) => {
    return initState
}

const insertCallContact = (state, action) => {
    const copyCalls = JSON.parse(JSON.stringify(state.calls))
    const mainPhone = action.contact.mainPhone.startsWith('+972') ? action.contact.mainPhone.replace('+972', '0') : action.contact.mainPhone
    copyCalls.forEach((call) => {
        if (!call.contactId) { //add contact only if not exist on call
            if (call.telephone === mainPhone) {
                call.contactId = action.contact
            }
        }
    })

    return updateObject(state, {
        calls: copyCalls
    })
}

const updateCallContact = (state, action) => {
    const copyCalls = JSON.parse(JSON.stringify(state.calls))
    copyCalls.forEach((call) => {
        if (call.contactId?._id === action.contact._id) {
            call.contactId = action.contact
        }
    })

    return updateObject(state, {
        calls: copyCalls
    })
}

const deleteCallContact = (state, action) => {
    const copyCalls = JSON.parse(JSON.stringify(state.calls))

    copyCalls.forEach((call) => {
        if (call.contactId?._id === action.contact._id) {
            call.contactId = null
        }
    })

    return updateObject(state, {
        calls: copyCalls
    })
}

const insertDialListContact = (state, action) => {
    const copyDialList = JSON.parse(JSON.stringify(state.dialList))
    const mainPhone = action.contact.mainPhone.startsWith('+972') ? action.contact.mainPhone.replace('+972', '0') : action.contact.mainPhone
    copyDialList.forEach((dialItem) => {
        if (!dialItem.contactId) { //add contact only if not exist on conv
            if (dialItem.telephone === mainPhone) {
                dialItem.contactId = action.contact
            }
        }
    })

    return updateObject(state, {
        dialList: copyDialList
    })
}

const updateDialListContact = (state, action) => {
    const copyDialList = JSON.parse(JSON.stringify(state.dialList))
    copyDialList.forEach((dialItem) => {
        if (dialItem.contactId?._id === action.contact._id) {
            dialItem.contactId = action.contact
        }
    })

    return updateObject(state, {
        dialList: copyDialList
    })
}

const deleteDialListContact = (state, action) => {
    const copyDialList = JSON.parse(JSON.stringify(state.dialList))

    copyDialList.forEach((dialItem) => {
        if (dialItem.contactId?._id === action.contact._id) {
            dialItem.contactId = null
        }
    })

    return updateObject(state, {
        dialList: copyDialList
    })
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case actionType.CALL_RECEIVED_EVENT: return CallReceivedEvent(state, action);
        case actionType.CALL_ANSWERED_EVENT: return CallAnsweredEvent(state, action);
        case actionType.CALL_RELEASED_EVENT: return CallReleasedEvent(state, action);
        case actionType.CALL_CONF_START: return CallConfStart(state, action);
        case actionType.FETCH_CALLS_SUCCESS: return fetchCallsSuccess(state, action);
        case actionType.CALL_DETAILS_UPDATE: return callDetailsUpdate(state, action);
        case actionType.DIAL_LIST_DETAILS_UPDATE: return dialListDetailsUpdate(state, action);
        case actionType.FETCH_DIAL_LIST_SUCCESS: return fetchDialList(state, action);
        case actionType.DIAL_LIST_ADDED: return dialListAdded(state, action);
        case actionType.DIAL_LIST_UPDATED: return dialListUpdated(state, action);
        case actionType.DIAL_LIST_DELETED: return dialListDeleted(state, action);
        case actionType.DIAL_LIST_AUTO_DELETED: return dialListAutoDeleted(state, action);
        case actionType.CALL_DELETED_EVENT: return callDeleted(state, action);
        case actionType.CLEAR_NOW_CALL: return clearNowCall(state, action);
        case actionType.MULTI_SELECT_UNSELECT_CALLS: return multiSelectUnselectCalls(state, action);
        case actionType.MULTI_SELECT_UNSELECT_ALL_CALLS: return multiSelectUnselectAllCalls(state, action);
        case actionType.MULTI_SELECT_UNSELECT_DIALLIST: return multiSelectUnselectDialList(state, action);
        case actionType.MULTI_SELECT_UNSELECT_ALL_DIALLIST: return multiSelectUnselectAllDialList(state, action);//CLEAR_DIALER_STATE
        case actionType.CLEAR_DIALER_STATE: return clearDialerState(state, action);
        case actionType.HOLD_STATUS_CHANGED: return callHoldEvent(state, action);
        case actionType.INSERT_CALL_CONTACT: return insertCallContact(state, action);
        case actionType.UPDATE_CALL_CONTACT: return updateCallContact(state, action);
        case actionType.DELETE_CALL_CONTACT: return deleteCallContact(state, action);
        case actionType.INSERT_DIALLIST_CONTACT: return insertDialListContact(state, action);
        case actionType.UPDATE_DIALLIST_CONTACT: return updateDialListContact(state, action);
        case actionType.DELETE_DIALLIST_CONTACT: return deleteDialListContact(state, action);
        default:
            return state
    }
}

export default reducer;